import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export function loggerCallback(logLevel: LogLevel, message: string): void {
  if (logLevel <= LogLevel.Warning) {
    console.log(message);
  }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: `https://login.microsoftonline.com/${environment.tenant}/`,
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  const apiEndpoint = environment.apiEndpoint.replace(/\/$/, '');

  // Every OrderFlow API route under /api/** requires the same consent scope, so a single
  // catch-all entry covers all of them. Previously each resource also had its own explicit
  // entry (e.g. /api/orders and /api/orders/*), which always overlapped with this catch-all
  // and made MsalInterceptor log "More than 1 matching scopes for endpoint found" on every
  // request — harmless since the scopes were identical, but noisy.
  protectedResourceMap.set(`${apiEndpoint}/api/**`, environment.consentScopes);
  protectedResourceMap.set(environment.graphEndpoint, ['User.Read', 'User.ReadBasic.All']);

  if (environment.staffInitialsApi.endpoint !== null && environment.staffInitialsApi.consentScopes !== null) {
    protectedResourceMap.set(
      `${environment.staffInitialsApi.endpoint}/api/users`,
      environment.staffInitialsApi.consentScopes
    );
    protectedResourceMap.set(
      `${environment.staffInitialsApi.endpoint}/api/users/*`,
      environment.staffInitialsApi.consentScopes
    );
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.consentScopes
    },
    loginFailedRoute: '/login-failed'
  };
}
